import script from "./rec-quantity-entries.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-quantity-entries.vue?vue&type=script&lang=ts&setup=true"

import "./rec-quantity-entries.vue?vue&type=style&index=0&id=27cdea02&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27cdea02"]])

export default __exports__